module.exports = __webpack_public_path__ + "media/2022/Today-1754a421.png";